module.exports = __webpack_public_path__ + "img/veterinarian-en.fa687868.svg";